const GeneralConfig = {
  homepage: 'https://order.louregelateria.id',
  apiHostname: 'https://api.louregelateria.id',
  hostname: 'https://order.louregelateria.id',
  assetsHostname: 'https://api.louregelateria.id',
  /*homepage: 'http://localhost:3000',
  apiHostname: 'http://localhost:8000',
  hostname: 'http://localhost:3000',
  assetsHostname: 'http://localhost:8000',*/
  dateFormat: 'DD/MM/YYYY',
  googleClientId: '',
  facebookAppId: '',
  whatsappPhone: '6451154612'
};

export default GeneralConfig;
